<template>
    <div>

        <section class="top-header">
            <div class="container">

                <div class="row">

                    <div class="col-md-12">
                        <div class="top-header__content">
                            <div class="top-header__content__header">
                                You already know how much you love your Tempur-Pedic<sup>®</sup> Pillow!
                                <br class="d-none d-lg-block">
                                Now you can get rewarded for it!
                            </div>

                            <hr class="top-header__content__hr"></hr>

                            <div class="top-header__content__subtext">
                                Use this page to share what you love about your Tempur-Pedic<sup>®</sup> Pillow and be entered to <strong>WIN $2,500!</strong>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>

        <section class="main-entry">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 ml-auto mr-auto">

                        <form id="entry-form" name="entry-form" v-on:submit.prevent autocomplete="off">
                            <!-- Email -->
                            <div class="col-md-12 mb-4">
                                <div class="main-entry__step">
                                    Step 1
                                </div>

                                <label for="componentEntryFormData-email" class="text-primary">Enter your email address. <span class="text-danger">(required)</span></label>
                                <div
                                    class="input-group mb-3"
                                    v-bind:class="{ 'form-validation-error': $v.componentEntryFormData.email.$error, 'form-validation-success': !$v.componentEntryFormData.email.$invalid && $v.componentEntryFormData.email.$dirty }"
                                >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="componentEntryFormData-email"
                                        name="componentEntryFormData-email"
                                        v-model.trim="componentEntryFormData.email"
                                        @input="(!$v.componentEntryFormData.email.$invalid) ? $v.componentEntryFormData.email.$touch() : ''"
                                    >
                                    <div class="input-group-append">
                                        <span class="input-group-text"></span>
                                    </div>
                                </div>
                                <div class="form-validation-message" v-if="$v.componentEntryFormData.email.$error">Please enter a valid email address.</div>
                            </div>

                            <!-- Share Copy -->
                            <div class="col-md-12 mb-2">
                                <div class="main-entry__step">
                                    Step 2
                                </div>

                                <div
                                    class="form-group"
                                    v-bind:class="{ 'form-validation-error': $v.componentEntryFormData.shareText.$error, 'form-validation-success': !$v.componentEntryFormData.shareText.$invalid && $v.componentEntryFormData.shareText.$dirty }" >
                                    <label for="componentEntryFormData-shareText">Edit the content below. <span>(optional)</span></label>
                                    <textarea
                                        type="text"
                                        class="form-control"
                                        id="componentEntryFormData-shareText"
                                        name="componentEntryFormData-shareText"
                                        v-model.trim="componentEntryFormData.shareText"
                                        @input="$v.componentEntryFormData.shareText.$touch()"
                                    ></textarea>
                                    <div class="form-validation-message" v-if="$v.componentEntryFormData.shareText.$error">Please enter text to share.</div>
                                </div>
                            </div>

                            <!-- Share Copy Button -->
                            <div class="col-md-12 mb-4">
                                <div class="text-left">
                                    <button
                                        class="btn btn-block btn-blue"
                                        v-clipboard:copy="componentEntryFormData.shareText"
                                        v-clipboard:success="handleCopyStatusSuccess"
                                        v-clipboard:error="handleCopyStatusError"
                                        >
                                        <i class="fa fa-copy fa-fw"></i> Copy Share Text
                                    </button>
                                </div>
                            </div>

                            <!-- Recaptcha -->
                            <div class="col-md-12 mb-4">
                                <div class="main-entry__step">
                                    Step 3
                                </div>

                                <label>Confirm you're a human. <span class="text-danger">(required)</span></label>

                                <recaptcha
                                    ref="recaptcha"
                                    :sitekey="'6LfM8kUUAAAAAMtLbbLT3JuZCH4OXKAB_FNzGMW-'"
                                    :size="'normal'"
                                ></recaptcha>
                            </div>

                            <!-- Share Buttons -->
                            <div class="col-md-12 mb-4">
                                <div class="main-entry__step">
                                    Step 4
                                </div>

                                <label>Share to Facebook or Twitter <span class="text-danger">(required)</span></label>
                                <span v-if="pending"><i class="fa fa-cog fa-spin"></i></span>

                                <div class="share-button-wrapper">

                                    <div @click="changeShareSelectedType('facebook')" class="share-button share-button--facebook">
                                        <div class="share-button__icon share-button__icon--facebook">
                                            <i class="fa-brands fa-facebook"></i>
                                        </div>
                                        <div class="share-button__text share-button__text--facebook">
                                            Facebook
                                        </div>
                                    </div>

                                    <div @click="changeShareSelectedType('twitter')" class="share-button share-button--twitter">
                                        <div class="share-button__icon share-button__icon--twitter">
                                            <i class="fa-brands fa-x-twitter"></i>
                                        </div>
                                        <div class="share-button__text share-button__text--twitter">
                                            Twitter
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </section>

        <b-modal
        class="main-modal"
        ref="showResultModal"
        size="md"
        ok-only
        ok-title="Done"
        >
            <div class="d-block">

                <div class="row">
                    <div class="col-md-12">
                        <img src="/static/images/main/tempurpedic-logo.png" class="header-image img-fluid" alt="Tempur-Pedic">
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="icon-block">
                           <br><br>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p class="text-content"><i class="fa fa-check-circle"></i> Thank you for choosing to share on {{this.uppercaseWord(this.shareTypeSelected)}}. Your entry has been collected.</p>
                    </div>
                </div>

            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { required, email } from 'vuelidate/lib/validators'
    import groupLegIdentification from '@/common/groupLegIdentification'
    import Recaptcha from '@/components/Partials/Components/Recaptcha'

    export default {
        name: 'home',
        data () {
            return {
                componentEntryFormData: {
                    email: '',
                    shareText: 'Just had to share the love! My new TEMPUR-Pedic pillow is like no other pillow. So unbelievably comfortable and I sleep like a dream! No comparison. ',
                    shareType: '',
                    program: 'email',
                    group: 0,
                    leg: 0,
                    passedUrl: '',
                    captcha: ''
                },
                groupLegResult: {
                    group: 0,
                    leg: 0
                },
                shareTypeSelected: '',
                recaptchaResult: '',
                pending: false,
                completedOnce: false,
                popupWindow: null
            }
        },
        computed: {
            ...mapState({
                datetime: state => state.datetime.datetime
            }),
            queryUrl () {
                if (this.$route.query.url) {
                    return this.$route.query.url
                } else {
                    return 'https://www.tempurpillows.com/'
                }
            }
        },
        methods: {
            //
            // Modals
            //
            showResultModal () {
                this.$refs.showResultModal.show()
            },

            //
            // Share Type handling
            //
            changeShareSelectedType (shareTypeSelected) {
                if (this.$v.$invalid) { this.$v.$touch(); return }

                // Make sure recaptcha is set
                if (!this.recaptchaResult) {
                    this.$root.$emit('recaptchaReset')
                    this.$toasted.error('Hmm, that captcha doesn\'t seem correct. Make sure the recaptcha is completed. Please try again.')
                    return
                }

                this.shareTypeSelected = shareTypeSelected
                this.popupWindow = window.open('', 'Share', 'height=1,width=1')

                this.submit()
            },

            //
            // Recaptcha
            //
            resetRecaptchaResult () {
                this.recaptchaResult = ''
            },
            completeRecaptchaResult (recaptchaResult) {
                this.recaptchaResult = recaptchaResult
            },

            //
            // Form handling
            //
            // async recaptchaSubmitPartner () {
            //     // If form is valid, execute the recaptcha
            //     if (this.$v.$invalid) { this.$v.$touch(); return }
            //     this.$refs.recaptcha.execute()
            // },
            async submit () {
                this.pending = true

                this.componentEntryFormData.shareType = this.shareTypeSelected
                this.componentEntryFormData.group = this.groupLegResult.group
                this.componentEntryFormData.leg = this.groupLegResult.leg
                this.componentEntryFormData.passedUrl = (this.$route.query.url) ? this.$route.query.url : ''
                this.componentEntryFormData.captcha = this.recaptchaResult

                const { email, shareText, shareType, program, group, leg, passedUrl, captcha } = this.componentEntryFormData
                const entryFormDataForSubmission = {
                    email,
                    shareText,
                    shareType,
                    program,
                    group,
                    leg,
                    passedUrl,
                    captcha
                }

                try {
                    await this.$store.dispatch('general/createEntry', entryFormDataForSubmission)
                    this.handlePopupWindow()
                    this.completedOnce = true
                } catch (error) {
                    console.log(error)
                    if (!error.message) {
                        this.$toasted.error('There was an error connecting to the server. Please try again.')
                    } else if (error.message === 'INVALID_CAPTCHA') {
                        if (this.popupWindow) {
                            this.popupWindow.close()
                        }
                        this.$toasted.error('Hmm, that captcha doesn\'t seem correct. Make sure the recaptcha is completed. Please try again.')
                    } else if (error.message === 'DUPLICATE_EMAIL_LEG') {
                        // this.$toasted.error('Thank you. Your entry has already been recieved for this month.')
                        this.handlePopupWindow()
                    } else {
                        if (this.popupWindow) {
                            this.handlePopupWindow()
                        }
                        this.$toasted.error('There was an error connecting to the server. Please try again.')
                    }
                } finally {
                    this.pending = false
                    this.$root.$emit('recaptchaReset')
                }
            },
            handlePopupWindow () {
                this.popupWindow.resizeTo('800', '600')

                this.showResultModal()

                // Handle the share functionality
                if (this.shareTypeSelected === 'facebook') {
                    this.popupWindow.location.replace('https://www.facebook.com/sharer/sharer.php?u=' + this.queryUrl)
                    this.popupWindow.blur()
                    this.popupWindow.focus()
                }
                if (this.shareTypeSelected === 'twitter') {
                    let urlData = {
                        'text': this.componentEntryFormData.shareText,
                        'hashtags': '',
                        'url': '',
                        'via': ''
                    }
                    let queryString = this.encodeQueryData(urlData)
                    this.popupWindow.location.replace('https://twitter.com/intent/tweet?' + queryString)
                    this.popupWindow.blur()
                    this.popupWindow.focus()
                }
            },

            //
            // Copy handling
            //
            handleCopyStatusSuccess (e) {
                if (!e.text) {
                    this.$toasted.error('Hmm, there was no text to copy...')
                }

                this.$toasted.success('Copied! - ' + e.text)
            },
            handleCopyStatusError () {
                this.$toasted.error('There was an error copying that text.')
            },

            //
            // Social sharing
            //
            // socialShareFacebook () {
            //     window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.queryUrl, 'Share', 'height=600,width=800').focus()
            // },
            // socialShareTwitter () {
            //     let urlData = {
            //         'text': this.componentEntryFormData.shareText,
            //         'hashtags': '',
            //         'url': '',
            //         'via': ''
            //     }
            //     let queryString = this.encodeQueryData(urlData)
            //     window.open('https://twitter.com/intent/tweet?' + queryString, 'Share', 'height=600,width=800').focus()
            // },
            encodeQueryData (data) {
                var object = []
                for (var d in data) {
                    if (data[d]) {
                        object.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
                    }
                }
                return object.join('&')
            },

            uppercaseWord (word) {
                if (!word) {
                    return ''
                }
                return (word[0].toUpperCase() + word.substr(1))
            }
        },
        mounted () {
            // Register for recaptcha events
            this.$root.$on('recaptchaComplete', (e) => { this.completeRecaptchaResult(e) })
            this.$root.$on('recaptchaReset', (e) => { this.resetRecaptchaResult(e) })

            // Set shareText based on queryUrl
            this.componentEntryFormData.shareText = this.componentEntryFormData.shareText + this.queryUrl + ' #sweepstakes'

            // Grab the group/leg result
            this.groupLegResult = groupLegIdentification(
                (this.$route.query.d) ? this.$route.query.d : this.datetime
            )
        },
        validations: {
            componentEntryFormData: {
                email: {
                    required,
                    email
                },
                shareText: {
                    required
                }
            }
        },
        components: {
            Recaptcha
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';
</style>



// WEBPACK FOOTER //
// src/components/Layouts/Main/Home.vue